import checkForValueInUserAgent from '../check-for-value-in-useragent'

const isDebug = () => {
  return checkForValueInUserAgent('DEBUG')
}

export default isDebug
